const CalcIcon = (props) => (
    <svg
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M22.5455 24.3355L20.8973 22.6873L20 23.5846L22.5455 26.13L27 21.6755L26.1027 20.7782L22.5455 24.3355ZM16.8182 22.051H18.0909V23.3237H16.8182V22.051ZM13 22.051H14.2727V23.3237H13V22.051ZM20.6364 18.8691H21.9091V20.1419H20.6364V18.8691ZM16.8182 18.8691H18.0909V20.1419H16.8182V18.8691ZM13 18.8691H14.2727V20.1419H13V18.8691ZM20.6364 15.6873H21.9091V16.96H20.6364V15.6873ZM16.8182 15.6873H18.0909V16.96H16.8182V15.6873ZM13 15.6873H14.2727V16.96H13V15.6873ZM13 11.8691H21.9091V13.7782H13V11.8691Z"
            fill="currentColor"
        />
        <path
            d="M18.125 26.25H11.2531C10.9209 26.2497 10.6023 26.1175 10.3674 25.8826C10.1325 25.6477 10.0003 25.3291 10 24.9969V9.9975C10.0007 9.66685 10.1323 9.34992 10.3661 9.11611C10.5999 8.88231 10.9168 8.75066 11.2475 8.75H23.7525C24.0832 8.75066 24.4001 8.88231 24.6339 9.11611C24.8677 9.34992 24.9993 9.66685 25 9.9975V18.75H23.75V10H11.25V25H18.125V26.25Z"
            fill="currentColor"
        />
    </svg>
);

export default CalcIcon;
